'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { faClose } from '@fortawesome/pro-solid-svg-icons/faClose';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { Icon } from '@benzinga/core-ui';

interface Props {
  onSearch?: (searchInput: string) => void;
}

export const SimpleSearch: React.FC<Props> = ({ onSearch }) => {
  const [visible, setVisible] = React.useState(false);
  const searchInput = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    window.addEventListener(
      'keydown',
      event => {
        if (event.keyCode === 27) {
          setVisible(false);
        }
      },
      { once: true },
    );

    if (visible) {
      if (searchInput.current) {
        searchInput.current.focus();
      }
    }
  }, [visible]);

  const onSearchSubmit = event => {
    if (event.keyCode === 13) {
      const value = searchInput?.current?.value;
      if (onSearch && value) {
        onSearch(value);
      }
    }
  };

  return (
    <>
      <Icon className="cursor-pointer" icon={faSearch} onClick={() => setVisible(true)} />
      {visible && (
        <div
          className="bg-black w-full h-full fixed top-0 bottom-0 right-0 left-0 z-50 flex justify-center items-center"
          style={{ zIndex: 1000000000 }}
        >
          <Icon
            className="absolute top-4 right-4 text-4xl text-gray-400 hover:text-white cursor-pointer"
            icon={faClose}
            onClick={() => setVisible(false)}
          />
          <div className="px-5">
            <SimpleInput onKeyDown={onSearchSubmit} placeholder="Search..." ref={searchInput} type="text" />
            <p className="message text-lg font-light" style={{ color: '#777' }}>
              Type above and press <i>Enter</i> to search. Press <i>Esc</i> to cancel.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

const SimpleInput = styled.input`
  padding: 0;
  padding-bottom: 12px;
  margin-bottom: 22px;
  border: 0;
  border-bottom: 1px solid #ffffff21;
  height: auto;
  font-size: 60px;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  background: transparent;
  width: 100%;

  @media (max-width: 800px) {
    font-size: 32px;
  }

  &::placeholder {
    color: #fff;
  }
`;
